import React from "react";
import "aos/dist/aos.css";
import { MapPin } from "react-feather";
import { Button } from "react-bootstrap";

const venues = [
  {
    id: 1,
    imgSrc: "assets/img/venues/venues-04.jpg",
    name: "GreenField Sports",
    address: "1 Crowthorne Road, 4th Street, Chennai",
    rating: "20%",
    reviews: "300 Reviews",
  },
  {
    id: 2,
    imgSrc: "assets/img/venues/venues-05.jpg",
    name: "GreenField Sports",
    address: "1 Crowthorne Road, 4th Street, Chennai",
    rating: "20%",
    reviews: "300 Reviews",
  },
  {
    id: 3,
    imgSrc: "assets/img/venues/venues-06.jpg",
    name: "GreenField Sports",
    address: "1 Crowthorne Road, 4th Street, Chennai",
    rating: "20%",
    reviews: "300 Reviews",
  },
  {
    id: 4,
    imgSrc: "assets/img/venues/venues-07.jpg",
    name: "GreenField Sports",
    address: "1 Crowthorne Road, 4th Street, Chennai",
    rating: "20%",
    reviews: "300 Reviews",
  },
  {
    id: 5,
    imgSrc: "assets/img/venues/venues-08.jpg",
    name: "GreenField Sports",
    address: "1 Crowthorne Road, 4th Street, Chennai",
    rating: "20%",
    reviews: "300 Reviews",
  },
];

const VenueSection = () => {
  return (
    <section className="section court-near">
      <div className="container">
        <div className="section-heading aos" data-aos="fade-up">
          <h2>
            Find Turf's <span>On Your Convenient Hours</span>
          </h2>
          <p className="sub-title">
            Discover nearby Turf's for convenient and accessible gameplay.
          </p>
        </div>
        <div className="row">
          <div className="featured-slider-group aos" data-aos="fade-up">
            <div className="owl-carousel featured-venues-slider owl-theme">
              {venues.map((venue) => (
                <div
                  className="featured-venues-item court-near-item"
                  key={venue.id}
                >
                  <div className="listing-item mb-0">
                    <div className="listing-img">
                      <p href="#">
                        <img
                          src={venue.imgSrc}
                          alt="Venue"
                          className="img-fluid"
                        />
                      </p>
                      {/* <div className="fav-item-venues">
                        <div className="list-reviews coche-star">
                          <a href="#" className="fav-icon">
                            <Heart />
                          </a>
                        </div>
                      </div> */}
                    </div>
                    <div className="listing-content">
                      <h3 className="listing-title">
                        <p href="#">{venue.name}</p>
                      </h3>
                      <div className="listing-details-group">
                        <ul>
                          <li>
                            <span>
                              <MapPin /> {venue.address}
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="list-reviews near-review">
                        <div className="d-flex align-items-center">
                          <span className="rating-bg">{venue.rating}</span>
                          <span>{venue.reviews}</span>
                        </div>
                        <Button as="a" href="/booknow" variant="primary">
                          Book Now
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VenueSection;
